import React from "react";
import { StyleSheet, View } from "react-native";
import IconButton from "../../common/IconButton";
import ExpandingTextInput from "../../common/ExpandingTextInput";
type Props = {
  prompts: Array<string>;
  onChangePrompts: (arg0: Array<string>) => void;
};
export default function PromptList({ prompts, onChangePrompts }: Props) {
  const promptInputs = prompts.map((prompt, promptIndex) => (
    <View style={styles.hContainer} key={"prompt-" + promptIndex}>
      <ExpandingTextInput
        placeholder="Prompt"
        style={styles.promptInput}
        value={prompt}
        onChangeText={(text: string) =>
          onChangePrompts(
            prompts.map((value, index) =>
              index === promptIndex ? text : value
            )
          )
        }
      />
      <IconButton
        iconName="minus"
        onPress={() =>
          onChangePrompts(prompts.filter((_, index) => index !== promptIndex))
        }
      />
    </View>
  ));
  return (
    <View style={styles.container}>
      {promptInputs}
      <IconButton
        iconName="plus"
        style={{
          alignSelf: "begin",
        }}
        onPress={() => onChangePrompts([...prompts, ""])}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  container: {},
  promptInput: {
    padding: 7,
    margin: 5,
    borderWidth: 1,
    borderRadius: 3,
    borderColor: "black",
    width: "100%",
    fontSize: 14,
  },
  hContainer: {
    flexDirection: "row",
  },
});
